import { Tooltip, TooltipContent, TooltipTrigger } from '@newfront-insurance/core-ui/v2';
import { Download, ExternalLink, X } from 'lucide-react';
import type { ReactNode } from 'react';

const toolbarActionClassName =
  'flex size-7 shrink-0 items-center justify-center rounded-sm text-[#546a83] transition-colors hover:bg-[#f4f5f6] hover:text-[#262d46]';

function ToolbarActionTooltip({ children, label }: { children: ReactNode; label: string }) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent side="bottom">{label}</TooltipContent>
    </Tooltip>
  );
}

export function DocumentPreviewToolbarActions({
  fileUrl,
  onClose,
  showOpenInNewTab = false,
}: {
  fileUrl: string;
  onClose: () => void;
  showOpenInNewTab?: boolean;
}) {
  return (
    <>
      <ToolbarActionTooltip label="Download file">
        <a
          href={fileUrl}
          target="_blank"
          rel="noopener noreferrer"
          download
          aria-label="Download preview file"
          className={toolbarActionClassName}
        >
          <Download className="size-4" />
        </a>
      </ToolbarActionTooltip>
      {showOpenInNewTab ? (
        <ToolbarActionTooltip label="Preview in new tab">
          <a
            href={fileUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Open preview file in a new tab"
            className={toolbarActionClassName}
          >
            <ExternalLink className="size-4" />
          </a>
        </ToolbarActionTooltip>
      ) : null}
      <ToolbarActionTooltip label="Close">
        <button type="button" aria-label="Close preview" className={toolbarActionClassName} onClick={onClose}>
          <X className="size-4" />
        </button>
      </ToolbarActionTooltip>
    </>
  );
}
